import { ReportsActions } from '../actions/actionTypes'
import {
  Expenses,
  ExpensesZIPFile,
  PreAccountingRowInterface,
  ReportsSettingsInterface,
  ReportsStoreInterface,
  SaleInterface,
  TransactionsInterface,
} from '../Interfaces/ReportsInterface'
import { CustomerSalesInterface, ProductSalesInterface } from '../Interfaces/SalesInterface'
import { ReducerBuilder } from './ReducerBuilder'

type PayloadType =
  | SaleInterface[]
  | PreAccountingRowInterface[]
  | CustomerSalesInterface[]
  | ProductSalesInterface[]
  | ReportsSettingsInterface
  | TransactionsInterface
  | Expenses
  | ExpensesZIPFile

const initialState: ReportsStoreInterface = {
  settings: null,
  sales: [],
  transactions: { paid: [], created: [] },
  preAccounting: [],
  salesByProduct: [],
  salesByCustomer: [],
  allSalesByCustomer: [],
  expenses: null,
}

const setSales = (state: ReportsStoreInterface, payload: SaleInterface[]) => {
  return {
    ...state,
    sales: payload,
  }
}

const setTransactions = (state: ReportsStoreInterface, payload: TransactionsInterface) => {
  return {
    ...state,
    transactions: payload,
  }
}

const setPreAccounting = (state: ReportsStoreInterface, payload: PreAccountingRowInterface[]) => {
  return {
    ...state,
    preAccounting: payload,
  }
}

const setSalesByCustomer = (state: ReportsStoreInterface, payload: CustomerSalesInterface[]) => {
  return {
    ...state,
    salesByCustomer: payload,
  }
}

const setAllSalesByCustomer = (state: ReportsStoreInterface, payload: CustomerSalesInterface[]) => {
  return {
    ...state,
    allSalesByCustomer: payload,
  }
}

const setSalesByProduct = (state: ReportsStoreInterface, payload: ProductSalesInterface[]) => {
  const salesByProduct = payload && payload.filter((p) => p?.productName !== '')
  return {
    ...state,
    salesByProduct,
  }
}

const updateSettings = (state: ReportsStoreInterface, payload: ReportsSettingsInterface) => {
  return {
    ...state,
    settings: payload,
  }
}

const initiateZIPfile = (state: ReportsStoreInterface, payload: Expenses) => {
  if (payload.status === 200) {
    return {
      ...state,
      expenses: {
        zipID: payload.data,
        zipReady: false,
      },
    }
  }
}

const downloadZIPfile = (state: ReportsStoreInterface, payload: ExpensesZIPFile) => {
  if (payload.data.isZipFileReady) {
    return {
      ...state,
      expenses: {
        ...state.expenses,
        zipReady: payload.data.isZipFileReady,
        downloadLink: payload.data.downloadZipUrl,
      },
    }
  } else {
    return { ...state }
  }
}

export default new ReducerBuilder<ReportsStoreInterface, PayloadType>(initialState)
  .mapAction(ReportsActions.LOAD_SALES, setSales)
  .mapAction(ReportsActions.LOAD_TRANSACTIONS, setTransactions)
  .mapAction(ReportsActions.LOAD_PRE_ACCOUNTING, setPreAccounting)
  .mapAction(ReportsActions.LOAD_SALES_BY_CUSTOMER, setSalesByCustomer)
  .mapAction(ReportsActions.LOAD_ALL_SALES_BY_CUSTOMER, setAllSalesByCustomer)
  .mapAction(ReportsActions.LOAD_SALES_BY_PRODUCT, setSalesByProduct)
  .mapAction(ReportsActions.UPDATE_SETTINGS, updateSettings)
  .mapAction(ReportsActions.INITIATE_EXPENSES_ZIP, initiateZIPfile)
  .mapAction(ReportsActions.DOWNLOAD_EXPENSES_ZIP, downloadZIPfile)
  .build()
